import * as types from '../services/ShareLinksActionType';

const initialState = {
    links: [],
    loading: false,
    revoking: false,
    generating: false,
    generatedToken: null,
};

const shareLinksReducer = (state = initialState, action) => {
    switch (action.type) {
        case types.FETCH_SHARE_LINKS_REQUEST:
            return { ...state, loading: true };
        case types.FETCH_SHARE_LINKS_SUCCESS:
            return { ...state, loading: false, links: action.payload };
        case types.FETCH_SHARE_LINKS_FAILURE:
            return { ...state, loading: false };

        case types.REVOKE_LINK_REQUEST:
            return { ...state, revoking: true };
        case types.REVOKE_LINK_SUCCESS:
        case types.REVOKE_LINK_FAILURE:
            return { ...state, revoking: false };

        case types.GENERATE_LINK_REQUEST:
            return { ...state, generating: true, generatedToken: null };
        case types.GENERATE_LINK_SUCCESS:
            return { ...state, generating: false, generatedToken: action.payload };
        case types.GENERATE_LINK_FAILURE:
            return { ...state, generating: false };
        case types.CLEAR_GENERATED_LINK:
            return { ...state, generatedToken: null };

        default:
            return state;
    }
};

export default shareLinksReducer;
